import { connect } from 'react-redux';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import TemplateView, { DispatchPropsType, MapStatePropsType } from '../organisms/templates/templateView';
import { openSideBar } from '../../../../store/sidebar';
import { Instances, SideBarTypes } from '../../../../constants';
import { makeSelectInProgress, makeSelectObject, requestObject } from '../../../../store/Object';
import { IStateType } from '../../../../store/models/root.interface';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

const mapStateToProps = (state: IStateType) => ({
    params: getParams(state),
    templateViewDetails: makeSelectObject(Instances.smsTemplateView)(state) || {},
    inProgress: makeSelectInProgress(Instances.smsTemplateView)(state),
    data: state.SMSTemplates
});

const mapDispatchToProps = {
    onClose: () => closeSideBar(),
    onEdit: (params: any) => openSideBar(SideBarTypes.templateEditForm, { id: params.id }),
    onLoad: (params: any) => requestObject(Instances.smsTemplateView, undefined, undefined, 'get', true, true, undefined, null, params.id)
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(TemplateView));